import { CaseAnalyticsPanel } from './CaseAnalyticsPanel'
import { useCaseAnalytics, type CaseAnalyticsTab } from './useCaseAnalytics'
import type { CaseView } from '../../../types/case'
import type { ProgramFilingDetailView } from '../../../types/programFilingDetail'

export interface CaseAnalyticsContainerProps {
  caseView: CaseView
  filings: ProgramFilingDetailView[]
  /** Switches this same `CaseDetailScreen`'s tab state (in-shell, never a route navigation — design
   * doc §4's IA-budget table, RAID R-UX282-2). */
  onNavigateTab: (tab: CaseAnalyticsTab) => void
}

/**
 * Thin composition root wiring `useCaseAnalytics` (the real data) into `CaseAnalyticsPanel` (the
 * presentational scaffold) — kept as its own file so `CaseDetailScreen.tsx`'s own diff for adding
 * this tab is a one-line import + one branch, mirroring every other tab's own panel-per-file
 * convention on this screen.
 */
export function CaseAnalyticsContainer({ caseView, filings, onNavigateTab }: CaseAnalyticsContainerProps) {
  const analytics = useCaseAnalytics(caseView, filings, onNavigateTab)
  return <CaseAnalyticsPanel {...analytics} />
}
